<div class="chatbot-container">
  <div class="chatbot-header">
    <h6>Brijj Buddy</h6>
    <button class="close-btn" (click)="closeDialog.emit()">×</button>
  </div>
  <div class="chatbot-body" #scrollMe>
    <!-- Chat messages -->
    <div class="chat-messages">

      <!-- CHANGED: Display history of added products -->
      <ng-container *ngFor="let product of addedProducts; let i = index">
        <div class="chat-message user-message">
          <p><span class="fw-bold">Name: </span>{{ product.name }}.</p>
          <mat-icon class="user-icon">person</mat-icon>
        </div>

        <div class="chat-message user-message" *ngIf="product.description">
          <p>
            <span class="fw-bold">Description: </span>{{ product.description }}.
          </p>
          <mat-icon class="user-icon">person</mat-icon>
        </div>

        <div class="chat-message user-message" *ngIf="product.condition">
          <p>
            <span class="fw-bold">Condition: </span>{{ product.condition }}.
          </p>
          <mat-icon class="user-icon">person</mat-icon>
        </div>

        <div class="image-previews" *ngIf="product.images.length > 0">
          <div *ngFor="let image of product.images" class="image-preview">
            <img [src]="image" alt="Product Image" />
          </div>
        </div>
        <div class="chat-message ai-message">
          <mat-icon class="ai-icon">assistant</mat-icon>
          <p>
            Product added: <span class="checkmark">✔</span> {{ product.name }}.
          </p>
        </div>
      </ng-container>

      <!-- Product name prompt -->
                  <!--Greet & Product name prompt -->
      <div class="chat-message ai-message" *ngIf="currentStep >= 1">
        <mat-icon class="ai-icon">assistant</mat-icon>
        <p>
          <span *ngIf="showWelcomeMessage">Welcome to Brijj Buddy Lister. <br /></span>
          Please provide the Product you're adding.
        </p>
      </div>

      <!-- User-entered product name -->
      <div class="chat-message user-message" *ngIf="productName">
        <p>{{ productName }}.</p>
        <mat-icon class="user-icon">person</mat-icon>
      </div>

      <!-- Confirmation message -->
      <div class="chat-message ai-message" *ngIf="currentStep >= 2">
        <mat-icon class="ai-icon">assistant</mat-icon>
        <p>
          Got it! <br/>Add description, color of the {{ productName }}
        </p>
      </div>

      <!-- User-entered product description -->
      <div
        class="chat-message user-message"
        *ngIf="createProductRequest.description"
      >
        <p>{{ createProductRequest.description }}.</p>
        <mat-icon class="user-icon">person</mat-icon>
      </div>

      <!-- Condition message -->
      <div class="chat-message ai-message" *ngIf="currentStep >= 3">
        <mat-icon class="ai-icon">assistant</mat-icon>
        <p>
          Great! <span class="checkmark">✔</span> I've noted the product
          details.<br />
          Please provide a condition of the product (e.g., New, Used, Good,
          Superb, etc.).
        </p>
      </div>

      <!-- User-entered product description -->
      <div class="chat-message user-message" *ngIf="currentStep >= 3">
        <select
          class="form-select"
          [(ngModel)]="createProductRequest.listerProduct.condition"
          aria-label="Default select example"
          id="productCondition"
          (change)="conditionSelected()"
        >
          <option [ngValue]="0" hidden>Select product condition</option>
          <option
            *ngFor="let item of productConditionsList"
            [ngValue]="item.id"
          >
            {{ item.name }}
          </option>
        </select>
        <mat-icon class="user-icon">person</mat-icon>
      </div>

      <!-- CHANGED: Image upload hint and buttons -->
      <div
        class="chat-message ai-message"
        *ngIf="currentStep >= 4 && !showImagePopup"
      >
        <mat-icon class="ai-icon">assistant</mat-icon>
        <p>Please upload one or more images of your product to showcase it.</p>
      </div>

      <!-- Image upload button -->
      <div class="chat-options" *ngIf="currentStep === 4 && !showImagePopup">
        <div class="option-btn upload-btn" (click)="openImagePopup()">
          Upload Images
        </div>
        <!-- Added for camera capture: Button to open camera popup -->
        <div class="option-btn camera-btn" (click)="openCamera()">
          Capture from Camera
        </div>
      </div>

      <!-- Display uploaded images -->
      <div class="image-previews" *ngIf="imagePreviewUrl.length > 0">
        <div
          *ngFor="let preview of imagePreviewUrl; let i = index"
          class="image-preview"
        >
          <img [src]="preview" alt="Preview" />
          <button class="remove-image" (click)="removeImage(i)">×</button>
        </div>
      </div>

      <!-- Loader during API calls -->
      <div class="chat-message ai-message" *ngIf="isLoading">
        <div class="loader"></div>
        <p>Analyzing product...</p>
      </div>
    </div>

    <!-- Image upload popup (inside chatbox) -->
    <div class="image-popup" *ngIf="showImagePopup">
      <div class="popup-content">
        <div class="popup-header">
          <h6>Upload Your Images</h6>
          <button class="popup-close-btn" (click)="closeImagePopup()">×</button>
        </div>
        <div class="popup-body">
          <div
            class="dropzone"
            (drop)="handleDrop($event)"
            (dragover)="handleDragOver($event)"
            (dragleave)="handleDragLeave($event)"
          >
            <div class="upload-icon">📁</div>
            <p>Drag and drop images here</p>
            <input
              type="file"
              multiple
              accept=".jpg,.jpeg,.png,.gif,.bmp,.tif,.tiff"
              (change)="onImageUpload($event)"
              class="file-input"
            />
          </div>

          <!-- Added for camera capture: Button to open camera -->
          <div class="camera-btn-container">
            <!-- <button class="option-btn" (click)="openCamera()">Capture from Camera</button> -->
          </div>

          <div class="image-previews" *ngIf="imagePreviewUrl.length > 0">
            <div
              *ngFor="let preview of imagePreviewUrl; let i = index"
              class="image-preview"
            >
              <img [src]="preview" alt="Preview" />
              <button class="remove-image" (click)="removeImage(i)">×</button>
            </div>
          </div>
        </div>

        <div class="popup-footer">
          <button
            class="submit-btn"
            (click)="submitImages()"
            [disabled]="imagePreviewUrl.length === 0"
          >
            Upload Images
          </button>
        </div>
      </div>
    </div>
    <!-- Added for camera capture: Camera capture popup -->
    <div class="image-popup" *ngIf="showCameraPopup">
      <div class="popup-content">
        <div class="popup-header">
          <h6>Capture Image</h6>
          <button class="popup-close-btn" (click)="closeCamera()">×</button>
        </div>
        <div class="popup-body">
          <video #videoElement autoplay class="camera-video"></video>
          <canvas #canvasElement style="display: none"></canvas>
          <div class="camera-controls" *ngIf="!capturedImage">
            <button class="submit-btn" (click)="captureImage()">Capture</button>
          </div>
          <canvas #canvasElement style="display: none"></canvas>
          <div class="captured-image" *ngIf="capturedImage">
            <img [src]="capturedImage" alt="Captured Image" />
            <div class="camera-controls">
              <button class="submit-btn" (click)="retakeImage()">Retake</button>
              <button class="submit-btn" (click)="addCapturedImage()">
                Add Image
              </button>
            </div>
          </div>
          <div class="image-previews" *ngIf="imagePreviewUrl.length > 0">
            <div
              *ngFor="let preview of imagePreviewUrl; let i = index"
              class="image-preview"
            >
              <img [src]="preview" alt="Preview" />
              <button class="remove-image" (click)="removeImage(i)">×</button>
            </div>
          </div>
        </div>
        <div class="popup-footer">
          <button
            class="submit-btn"
            (click)="submitImages()"
            [disabled]="imagePreviewUrl.length === 0"
          >
            Upload Images
          </button>
        </div>
      </div>
    </div>

    <!-- Notification Popup -->
    <!-- CHANGED: Added notification popup for errors, success, and warnings -->
    <div class="notification-popup" *ngIf="showNotification">
      <div class="notification-content" [ngClass]="notificationType">
        <div class="notification-icon">
          <mat-icon>{{ notificationIcon }}</mat-icon>
        </div>
        <div class="notification-message">
          <h6>{{ notificationTitle }}</h6>
          <p>{{ notificationMessage }}</p>
        </div>
        <button class="notification-close-btn" (click)="closeNotification()">
          ×
        </button>
      </div>
    </div>

    <!-- Thank you popup  -->

    <div class="thank-you-popup" *ngIf="showThankYouPopup">
      <div class="popup-content">
        <button class="popup-close-btn" (click)="closeThankYouPopup()">
          ×
        </button>

        <div class="svg-icon" style="color: #0070b9">
          <svg
            width="64"
            height="64"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <path d="M9 12l2 2l4 -4" />
          </svg>
        </div>

        <h2 class="thank-you-title">Thank You !</h2>
        <p class="thank-you-subtext">
          Your product has been added to the product list.
        </p>
        <button class="done-btn" (click)="closeBot()">Done</button>
      </div>
    </div>
  </div>

  <!-- CHANGED: Add New Product Popup -->
  <div class="add-new-product-popup" *ngIf="showAddNewProductPopup">
    <div class="popup-content">
      <button class="popup-close-btn" (click)="closeAddNewProductPopup()">
        ×
      </button>
      <div class="svg-icon" style="color: #0070b9">
        <svg
          width="64"
          height="64"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <circle cx="12" cy="12" r="10" />
          <path d="M9 12l2 2l4 -4" />
        </svg>
      </div>
      <h2 class="add-new-product-title">Product Added!</h2>
      <p class="add-new-product-subtext">
        Would you like to add another product?
      </p>
      <div class="popup-buttons">
        <button class="option-btn yes-btn" (click)="addAnotherProduct()">
          Yes
        </button>
        <button class="option-btn no-btn" (click)="showThankYou()">No</button>
      </div>
    </div>
  </div>
  <!-- Product name input  -->

  <div class="chat-input">
    <!-- Product name input -->
    <input
      *ngIf="currentStep === 1"
      type="text"
      [(ngModel)]="productNameInput"
      placeholder="Enter product name"
      (keyup.enter)="submitProductName()"
    />
    <!-- CHANGED: Description input with hint -->
    <textarea
      *ngIf="currentStep === 2"
      class="description-textarea"
      [(ngModel)]="productDescriptionInput"
      placeholder="Enter product description (e.g., brand, color, condition, material)"
      (keyup.enter)="submitProductDescription()"
    ></textarea>
    <button
      *ngIf="currentStep === 1"
      (click)="submitProductName()"
      [disabled]="!productNameInput.trim()"
    >
      ➤
    </button>
    <button
      *ngIf="currentStep === 2"
      (click)="submitProductDescription()"
      [disabled]="!productDescriptionInput.trim()"
    >
      ➤
    </button>
  </div>
</div>
